import React from 'react';
import { chakra, forwardRef } from '@chakra-ui/react';
import { motion, isValidMotionProp } from 'framer-motion';

export const MotionDivider = motion(
  forwardRef((props, ref) => {
    const chakraProps = Object.fromEntries(
      // do not pass framer props to DOM element
      Object.entries(props).filter(([key]) => !isValidMotionProp(key))
    );
    return <chakra.hr ref={ref} {...chakraProps} />;
  })
);
